import { Ship, Construction, Building2, Train, Zap, Factory, Cog, Fuel, Pickaxe, Shield } from "lucide-react";

const INDUSTRIES = [
  { icon: Train, name: "Railways" },
  { icon: Construction, name: "Infrastructure & Construction" },
  { icon: Fuel, name: "Oil & Gas" },
  { icon: Pickaxe, name: "Mining" },
  { icon: Factory, name: "Steel Plants" },
  { icon: Zap, name: "Power Generation" },
  { icon: Cog, name: "Fabrication & Engineering" },
  { icon: Shield, name: "Defence" },
  { icon: Ship, name: "Shipbuilding" },
  { icon: Building2, name: "Manufacturing Industries" },
];

export const Industries = () => {
  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="relative bg-[#0E1116] py-24 md:py-32 border-t border-[#F5F1EA]/8"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-14">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-brand-red" />
              <span data-testid="industries-eyebrow" className="text-[11px] uppercase tracking-[0.35em] text-brand-red font-medium font-sans">
                Industries We Serve
              </span>
            </div>
            <h2
              data-testid="industries-heading"
              className="font-display tracking-tight text-white text-3xl md:text-4xl lg:text-5xl leading-[1.1] font-medium"
            >
              Trusted Across <span className="italic text-brand-red font-normal">Heavy Industries</span> <br />
              of India.
            </h2>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <p className="text-base text-[#A8A29A] leading-relaxed font-sans">
              From shipyards to power plants, defence establishments to steel mills — our cables and hoses are the silent infrastructure behind India&apos;s industrial work.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-px bg-[#F5F1EA]/8">
          {INDUSTRIES.map((ind, i) => {
            const Icon = ind.icon;
            return (
              <div
                key={i}
                data-testid={`industry-${i}`}
                className="group bg-[#0E1116] hover:bg-[#161A21] transition-colors p-6 md:p-8 flex flex-col items-start gap-4 min-h-[160px]"
              >
                <div className="p-3 bg-[#1D222B] border border-[#F5F1EA]/8 group-hover:border-brand-red/40 transition-colors">
                  <Icon size={20} className="text-brand-red" strokeWidth={1.5} />
                </div>
                <div>
                  <div className="text-[10px] uppercase tracking-[0.3em] text-[#A8A29A]/70 mb-1 font-sans">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <div className="font-display tracking-tight text-white text-base md:text-lg leading-tight font-medium">
                    {ind.name}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
